import ProjectManagement from "../features/projectmanagement";
import { PortfolioTestResultsPage } from "../pages/management";
import ManagementCampaignRoutes from "./management.campaign.routes";
import ManagementReportingRoutes from "./management.reporting.routes";
import ManagementReportRoutes from "./management.reports.routes";
import ManagementReviewsRoutes from "./management.reviews.routes";
import ManagementServiceTermsRoutes from "./management.serviceterms.routes";

const ManagementRoutes = [{
    path: "/management/*",
    roles: [],
    children: [
        ManagementReportRoutes,
        ManagementReviewsRoutes,
        ManagementReportingRoutes,
        ManagementCampaignRoutes,
        ManagementServiceTermsRoutes,
        { 
            path: 'projects', 
            roles: [],
            element: ProjectManagement
        },
        {
            path: 'portfolio-testing',
            roles: ['sys_admin_access', 'ic_test_results'],
            element: PortfolioTestResultsPage
        }
    ]
}];

export default ManagementRoutes;